export default __webpack_public_path__ + "static/media/cart.f5476182.svg";